import React, { useState } from 'react'


// border-blue-800 border-solid border-[3px]


function Events() {
    const [expandedIndexes, setExpandedIndexes] = useState({ 1: true });
    const toggleAnswer = (index) => {
        setExpandedIndexes({ [index]: !expandedIndexes[index] });
    };
    const manualIndex = [1, 2, 3, 4, 5];

    return (
        <>
            <div className="flex flex-col px-5 mt-20">
                <div className="self-start text-5xl font-bold text-right whitespace-nowrap text-zinc-900">
                    أحداث ومناسبات
                </div>
                <div className='flex flex-col gap-4 mt-11'>

                    {manualIndex.map((index) => (
                        <div key={index} className='border border-gray-200 border-solid rounded-2xl bg-zinc-50'>
                            <div className="flex gap-5 justify-between px-9 py-6 w-full max-md:flex-wrap max-md:px-5 max-md:mt-10 max-md:max-w-full">
                                <div className="flex gap-5">
                                    <div className="flex flex-col justify-center px-3.5 py-5 whitespace-nowrap rounded-lg border border-solid basis-0 border-stone-300 text-zinc-700">
                                        <div className="text-2xl leading-7 text-center">28</div>
                                        <div className="text-base font-medium leading-5 text-right">
                                            مارس
                                        </div>
                                    </div>
                                    <div className="flex flex-col grow shrink-0 my-auto font-medium text-right basis-0 w-fit">
                                        <div className="self-start text-2xl leading-5 text-black whitespace-nowrap">
                                            تشجير مناطق سكنية
                                        </div>
                                        <div className="flex gap-5 justify-between mt-3 w-full text-base leading-5">
                                            <div className="flex flex-1 gap-2 justify-start py-2 text-black whitespace-nowrap rounded-2xl">
                                                <img
                                                    loading="lazy"
                                                    src="https://www.riyadhenv.gov.sa/wp-content/uploads/2016/12/DSC_0049.jpg"
                                                    className="shrink-0 w-6 aspect-square"
                                                />
                                                <div className="grow my-auto">تركيا - أضنة</div>
                                            </div>
                                            <div className="flex my-auto text-emerald-600">
                                                المناسبة قادمة قريباً
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <img
                                    onClick={() => toggleAnswer(index)}
                                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/f28ae3a5eacc87f1d9bccad178c4f72348c1563f315d22e45ded47143ed1a8d5?"
                                    className={`shrink-0 my-auto w-6 aspect-square ${expandedIndexes[index] && 'transform rotate-180'}`}
                                />
                            </div>
                            {expandedIndexes[index] &&
                                <div className="flex flex-col px-8 py-7 w-full max-md:px-5 max-md:max-w-full
                            
                            ">
                                    <span className='border-b border-solid border-1.5 flex w-[100%] m-auto'></span>
                                    <div className="justify-start mt-10 max-md:max-w-full">
                                        <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                                            <div className="flex flex-col w-[28%] max-md:ml-0 max-md:w-full">
                                                <img
                                                    loading="lazy"
                                                    srcSet="https://www.riyadhenv.gov.sa/wp-content/uploads/2016/12/DSC_0049.jpg"
                                                    className="grow w-full aspect-[1.67] max-md:mt-5 object-cover"
                                                />
                                            </div>
                                            <div className="flex flex-col w-[72%] max-md:ml-0 max-md:w-full">
                                                <div className="flex flex-col max-md:mt-5 max-md:max-w-full">
                                                    <div className="text-base leading-6 text-right text-neutral-900 max-md:max-w-full">
                                                        الحدث هو فرصة فريدة للمشاركين في تجربة تجمع بين التعلم
                                                        والتفاعل والتأثير الإيجابي. يشمل الحدث مجموعة متنوعة من
                                                        الأنشطة والجلسات وورش العمل التي تهدف إلى تعزيز الوعي بقضايا
                                                        إنسانية مهمة، وتوفير منصة للحوار وتبادل الأفكار، وتشجيع
                                                        المشاركين على العمل الجماعي من أجل تحقيق التغيير الإيجابي في
                                                        المجتمع. سواء كنت مهتمًا بالعمل الإنساني أو العمل الاجتماعي أو
                                                        مجرد الانخراط في تجربة ممتعة ومثرية، فإن هذا الحدث يوفر لك
                                                        الفرصة المثالية للمشاركة والمساهمة في مبادراتنا الإنسانية.
                                                    </div>
                                                    <div className="flex gap-5 justify-between self-start mt-3">
                                                        <div className="flex gap-3 justify-center">
                                                            <div className="flex justify-center items-center self-start px-3 w-12 h-12 bg-blue-500 rounded-[30px]">
                                                                <img
                                                                    loading="lazy"
                                                                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/56337107537cad025d4ed0de025cacc66492b6602177898520ff4811c9205275?"
                                                                    className="w-6 aspect-square"
                                                                />
                                                            </div>
                                                            <div className="flex flex-col flex-1 text-base whitespace-nowrap text-zinc-800">
                                                                <div className="font-light">التصنيف</div>
                                                                <div className="self-start ml-5 text-right max-md:ml-2.5">
                                                                    طعام
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="flex gap-3 justify-center">
                                                            <div className="flex justify-center items-center self-start px-3 w-12 h-12 bg-blue-500 rounded-[30px]">
                                                                <img
                                                                    loading="lazy"
                                                                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/e1e87defd40feee327267ae66eaf9d20f4912c6ba926e671b4762a57cac7895b?"
                                                                    className="w-6 aspect-square"
                                                                />
                                                            </div>
                                                            <div className="flex flex-col flex-1 text-base whitespace-nowrap text-zinc-800">
                                                                <div className="self-start font-light">وقت المناسبة</div>
                                                                <div className="text-right">10:00 ص حتى 05:00 م</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex self-end gap-3 pr-20 mt-5 max-md:flex-wrap max-md:pr-5">
                                        <div className="flex justify-center items-center px-3.5 py-2 bg-blue-600 rounded-lg shadow-sm">
                                            <img
                                                loading="lazy"
                                                src="https://cdn.builder.io/api/v1/image/assets/TEMP/bad1e4d8a6402dc2084ab725d8a72860fe5b230f00b5c70da4580c0252d4d49d?"
                                                className="w-5 aspect-square"
                                            />
                                        </div>
                                        <div className="justify-center px-3.5 py-2 text-sm font-medium leading-5 whitespace-nowrap bg-amber-300 rounded-lg shadow-sm text-neutral-900">
                                            اخرج زكاتك الان
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default Events